import React from 'react';
import './mainstyle.css';

const Footer = (props) => {
  return (
    <div className="foot">
        <div className="data">
        <a href="https://vinaykumarp1695.netlify.app/" target="_blank"><i class="far fa-user"></i></a>
        <a href="https://www.linkedin.com/in/vinay-kumar-p-20766214b/" target="_blank"><i class="fab fa-linkedin"></i></a>
        <a href="https://github.com/vinaykumarP16" target="_blank"><i class="fab fa-github-square"></i></a>
        <a href="mailto:vinaykumar.p1995v@gmail.com" ><i class="fas fa-envelope"></i></a>
        </div>
    </div>
  )
}

export default Footer;


